import { IoMdClose } from "react-icons/io";
import { useStyles } from "./style";
import supportCreated from "../../../Assets/img/supportDone.png"
import { Button } from "@material-ui/core";
import { WhatsApp } from "@material-ui/icons";
import { useHistory } from "react-router-dom";

export function SolicitacaoCriadaPage() {
    const classes = useStyles();
    const phoneNumber = '551152004015';
    const history = useHistory();

    const handleRedirectToWhatsapp = () => {
        const url = `https://wa.me/${phoneNumber}`;
        window.open(url, '_blank');
    };

    return (
        <div className="page-container">
            <div className="page-align" style={{ justifyContent: "flex-start" }}>
                <div className={classes.top}>
                    <IoMdClose
                        style={{
                            fontSize: "35px",
                            color: "#EA3458",
                            cursor: "pointer",
                            minWidth: "30px",
                            marginLeft: "-10px"

                        }}
                        onClick={() => history.push("/suporte-tecnico")}
                    />
                </div>
                <div className="infinite-scroll">
                    <div className={classes.container}>
                        <h2 className={classes.title}>
                            Solicitação criada com sucesso
                        </h2>
                        <img
                            src={supportCreated}
                            alt="Solicitação criada com sucesso"
                            className={classes.image}
                        />
                        <p className={classes.description}>
                            Por favor acompanhe o seu e-mail de cadastro, pois enviaremos as atualizações dessa solicitação através desse e-mail de contato.
                        </p>
                    </div>
                </div>
                <div className="footer-column">
                    <div className={classes.buttonContainer}>
                        <Button
                            variant="contained"
                            color="primary"
                            className={classes.button}
                            onClick={() => history.push("/suporte-tecnico")}
                        >
                            Ok, obrigado
                        </Button>
                        <div className={classes.whatsAppButton} onClick={handleRedirectToWhatsapp}>
                            <WhatsApp style={{ color: "#6DC89E" }} />
                            <span>Falar com o nosso atendimento</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}